










import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'top-banner',
    props: {
        src: {
            type: String,
            default: '',
        },
        rate: {
            type: Number,
            default: 0,
        },
    },
});
